import { useEffect, useMemo } from "react";
import { useCookies } from "react-cookie";
import useUserFields from "./useUserFields";
import { legacyCookieKey, tenantCookieKey } from "./tenantCookie";

// The key of the cookie `name` of the logged user on the current tenant (see
// tenantCookie.js). The cookie kept per user before is removed, not read: its
// values may belong to another tenant.
export default function useTenantCookieKey(name) {
  const { tenant, nickname } = useUserFields("tenant", "nickname");
  const key = useMemo(
    () => tenantCookieKey(name, tenant, nickname),
    [name, tenant, nickname]
  );
  const legacyKey = useMemo(
    () => legacyCookieKey(name, nickname),
    [name, nickname]
  );
  const [cookies, , removeCookie] = useCookies([legacyKey]);
  const hasLegacy = cookies[legacyKey] !== undefined;

  useEffect(() => {
    if (hasLegacy) removeCookie(legacyKey);
  }, [hasLegacy, legacyKey, removeCookie]);

  return key;
}
